export const StaticAPI = {
  initiateKyc: "/login",
  emailOtpVerify: "/verifyOtp",
  clientDetails: "/clientDetails",
  uploadImage: "/uploadImage",
  uploadPdf: "/uploadPdf",
  updateAccount: "/updateAccount",
  submit: "/submit",
};
